// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"84b2ea04","187":"aa20930d","330":"4a31e735","470":"22616de7","508":"bf5806cf","586":"dbf8be88","635":"69639f15","647":"380b938b","660":"044b67e3","717":"39111bd7","754":"70b8463b","919":"b5732e1f","953":"606aef65"}[chunkId] + ".chunk.js";
};